import { Axios, AxiosResponse } from 'axios'
import { RootState } from '@/store'
import { SonekiKeisanKmkTypeType } from '@/repositories/keiei-joho/data'
import { ResponseSonekiKeisanExportLayout, SonekiKeisanKmkType } from '@/repositories/keiei-joho/soneki-keisan/data'

type PostItem = {
  kmkType: SonekiKeisanKmkTypeType;
  kin: number | null;
}
type PostParamItem = {
  startDate: string;
  endDate: string;
  kmkTypes: PostItem[];
}

export interface SonekiKeisanExportRepository {
  checkCorporationInfoExists (): Promise<boolean>;
  getKmkTypes (): Promise<ResponseSonekiKeisanExportLayout>;
  save (allKmkTypes: SonekiKeisanKmkType[]): Promise<void>;
  recalculate (): Promise<ResponseSonekiKeisanExportLayout>;
  export (): Promise<AxiosResponse>;
}

export class SonekiKeisanExportRepositoryImpl implements SonekiKeisanExportRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/soneki-keisan/export`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  /**
   * 法人情報の存在チェック
   */
  async checkCorporationInfoExists (): Promise<boolean> {
    const { data } = await this.http.get(`${this.baseUrl}/check-corporation`)
    return data
  }

  /**
   * 損益計算書科目タイプと法人情報のデータ取得
   */
  async getKmkTypes (): Promise<ResponseSonekiKeisanExportLayout> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const { data } = await this.http.get(`${this.baseUrl}/${startDate}/${endDate}`)
    return data
  }

  /**
   * 登録
   */
  async save (allKmkTypes: SonekiKeisanKmkType[]): Promise<void> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const items: PostItem[] = allKmkTypes.map(p => ({
      kmkType: p.kmkType,
      kin: p.kin
    }))
    const postParam: PostParamItem = {
      startDate: startDate,
      endDate: endDate,
      kmkTypes: items
    }
    await this.http.post(`${this.baseUrl}/save`, postParam)
  }

  /**
   * 再集計
   */
  async recalculate (): Promise<ResponseSonekiKeisanExportLayout> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const { data } = await this.http.get(`${this.baseUrl}/recalculate/${startDate}/${endDate}`)
    return data
  }

  /**
   * 出力
   */
  async export (): Promise<AxiosResponse> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    return await this.http.post(`${this.baseUrl}/export/${startDate}/${endDate}`, {}, { responseType: 'blob' })
  }
}
